import { useQuery } from "@rocicorp/zero/react";
import { queries } from "../../../shared/queries";
import { personalVolumePath, spaceVolumePath } from "../../lib/apiPaths";
import type { StorageFileTarget } from "./storageUsageLevel";

type BoundVolume = {
  name: string;
  branchId: string;
  branch?: { name: string } | null;
};

// The listing route resolves a live volume through any main-branch row bound
// to it, and a draft through that branch’s row.
export function volumeListing(
  target: StorageFileTarget,
  volumes: readonly BoundVolume[],
  personalSpaceId: string | undefined
): { pathBase: string | null; branchId: string | null } {
  if (target.category === "personal_volume") {
    return {
      pathBase:
        personalSpaceId === target.spaceId
          ? personalVolumePath(target.volumeName)
          : null,
      branchId: null,
    };
  }
  const branchId =
    target.category === "branch_volume"
      ? target.branchId
      : (volumes.find(
          (volume) =>
            volume.name === target.volumeName && volume.branch?.name === "main"
        )?.branchId ?? null);
  return {
    pathBase:
      branchId && spaceVolumePath(target.spaceId, branchId, target.volumeName),
    branchId,
  };
}

export function useVolumeListingContext(spaceId: string) {
  const [volumes, volumesResult] = useQuery(queries.spaceVolumes({ spaceId }));
  const [personalSpace, personalResult] = useQuery(queries.personalSpace());
  return {
    volumes,
    personalSpaceId: personalSpace?.id,
    loading:
      volumesResult.type !== "complete" || personalResult.type !== "complete",
  };
}
